export const demoAccountEmail = 'demo@feedsubscription.com';
export const demoAccountPassword = 'This-account-is-for-Hacker-News';
